import { createStore as reduxCreateStore } from "redux";
import { devToolsEnhancer } from "redux-devtools-extension";

import rootReducer from "./reducers";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStore = () => reduxCreateStore(rootReducer, devToolsEnhancer({}));
export default createStore;
